module.exports = __webpack_public_path__ + "static/media/arrowUp.687c4af6.svg";